import React, { Component } from 'react'
import Router from '../Router'

// https://github.com/fkhadra/react-toastify#le-style
// https://fkhadra.github.io/react-toastify/
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { Header, Sidebar } from 'components/Navigations/index'
import Login from 'scenes/Login'
import jwt from '@credlock-x/jwt-node'
import AppContext from 'AppContext'
import { fetchOperators } from 'services/api/operators'
import { fetchLocations } from 'services/api/locations'
import { env } from 'components/Helpers'

class Main extends Component {
  constructor (props) {
    super(props)

    this.state = {
      mobile_nav_hidden: true,
      mobile_nav_class: 'hidden',
      selected_operator: undefined,
      authToken: props.authToken,
      appContext: {
        operator: {},
        user: {},
        currentAdmin: props.currentAdmin
      }
    }

    this._toggleMobileNav = this._toggleMobileNav.bind(this)
    this._login = this._login.bind(this)
  }

  componentDidMount () {
    if (!this.state.authToken) return

    // admin-auth-consolidation Phase 2 (S3.5): the post-auth operator bootstrap
    // no longer round-trips admin-api's /v0/login/admins (F313). The admin's own
    // operator id is already in the JWT (`_user().operator`); we fetch the
    // operator reference list (/v0/operators, now auth-gated) only to resolve
    // that id to its name/timezone for display and date formatting.
    fetchOperators((operators) => {
      const operator =
        operators.find(o => o.id === this._user().operator) || { id: this._user().operator }

      this.setInitState(operator)
    }, (err) => {
      console.error('Error for fetch all operators', err)
      // Still bootstrap on a failed reference lookup so the app initialises with
      // the JWT's operator id rather than being left un-initialised.
      this.setInitState({ id: this._user().operator })
    })

    // Locations feed filters and exports app-wide. They are token-scoped
    // server-side (the operator argument is ignored), so fetch them
    // independently of the operator reference — a failed operator lookup no
    // longer costs the locations.
    fetchLocations(null, {}, (locations) => {
      this.setState((prev) => ({
        appContext: { ...prev.appContext, locations: locations.data }
      }))
    })

    // Set selected operator based on url path
    const url = this._url()
    if (url.operatorID) {
      this.setState({ selected_operator: url.operatorID })
    }
  }

  render () {
    if (!this.state.authToken) {
      return (<Login login={this._login} />)
    }

    return (
      <div className='application'>
        <AppContext.Provider value={this.state.appContext}>
          <Header
            methods={{
              toggle_mobile_nav: this._toggleMobileNav
            }}
            error={this.state.error}
          />
          <Sidebar
            selected_operator={this.state.selected_operator}
            mobile_nav_hidden={this.state.mobile_nav_hidden}
            toggle_mobile_nav={this._toggleMobileNav}
            permissions={this._permissions()}
            logout={this.props.logout}
            env={env()}
          />
          <cl-donedone-conversation
            token={this.state.authToken}
            apihost={`https://donedone.${env()}.credlock.net`}
          />
          <Router
            selected_operator={this.state.selected_operator}
            user={this._user()}
          />
          <ToastContainer
            position='bottom-center'
            autoClose={3000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnVisibilityChange
            draggable
            pauseOnHover
          />
        </AppContext.Provider>
      </div>
    )
  }

  setInitState (operator) {
    this.setState((prev) => ({
      appContext: {
        ...prev.appContext,
        operator: operator,
        user: this._user(),
        currentAdmin: this.props.currentAdmin
      },
      selected_operator: operator.id
    }))
  }

  _user () {
    return jwt.ignoreSignature(this.state.authToken)
  }

  _permissions () {
    return this._user().permissions
  }

  _login (token) {
    this.setState({ authToken: token })
  }

  _toggleMobileNav () {
    this.setState({ mobile_nav_hidden: !this.state.mobile_nav_hidden })
  }

  _url () {
    const urlElements = window.location.pathname.split('/')

    return {
      elements: urlElements,
      base_path: urlElements[1],
      operatorID: urlElements[2]
    }
  }
}

export default Main
